<template>
  <v-row justify="center">
    <v-dialog v-model="dialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ dialog.title }}
        </v-card-title>
        <v-card-text>
          <v-alert v-if="!Array.isArray(dialog.content)" :type="dialogType(dialog.custom)" outlined>
            {{ dialog.content }}
          </v-alert>
          <v-alert
            v-else
            v-for="(item, index) in dialog.content"
            :key="index"
            :type="item.custom"
            outlined
          >
            {{ item.content }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="showButtonOk()"
            :color="secondaryColor(generalExApplicationEx)"
            text
            @click="clickOk"
          >
            {{ titleButtonOk() }}
          </v-btn>
          <v-btn
            v-if="showButtonCancel()"
            :color="secondaryColor(generalExApplicationEx)"
            text
            @click="clickCancel"
          >
            {{ titleButtonCancel() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "Dialog",
  props: ["dialog", "generalExApplicationEx"],
  data() {
    return {};
  },
  methods: {
    title() {
      return this.dialog.custom == "confirm"
        ? this.translatedText("dialogConfirmation")
        : this.dialog.custom == "error"
        ? this.translatedText("dialogError")
        : this.translatedText("dialogInformation");
    },
    showButtonOk() {
      return true;
    },
    showButtonCancel() {
      return this.dialog.custom == "confirm";
    },
    titleButtonOk() {
      return this.dialog.custom == "confirm" ? this.translatedText("confirmText") : "OK";
    },
    titleButtonCancel() {
      return this.translatedText("dialogCancel");
    },
    clickOk() {
      this.$emit("close-static-dialog", { result: true });
    },
    clickCancel() {
      this.$emit("close-static-dialog", { result: false });
    },
  },

  updated() {
    
  }
};
</script>

<style>
</style>